import { apiRequest } from './apiService';

// Sales Institutes
export const fetchSalesInstitutes = async () => {
  return await apiRequest('/sales/sales-institutes', 'GET');
};

export const createSalesInstitute = async (instituteData: any) => {
  return await apiRequest('/sales/sales-institutes', 'POST', instituteData);
};

export const fetchSalesInstituteById = async (id: any) => {
  return await apiRequest(`/sales/sales-institutes/${id}`, 'GET');
};

export const updateSalesInstitute = async (id: any, instituteData: any) => {
  return await apiRequest(
    `/sales/sales-institutes/${id}`,
    'PUT',
    instituteData
  );
};
